import {Grid} from "@mui/material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import {FormOWLocationGroupLocationModel} from "../../api/types/owLocationGroupLocation";
import {FormAutocomplete} from "../../common/form-fields";
import {useRecoilState} from "recoil";
import {owLocationGroupAtom} from "../../state/owLocationGroupsRecoil";
import {SelectElementModelFE} from "../../api/types/generic";
import {selectedOWLocationGroupLocationAtom} from "../../state/owLocationGroupLocationsRecoil";

const FormOWLocationGroupLocation = () => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Form Context
    const {register} = useFormContext<FormOWLocationGroupLocationModel>();

    // Use Recoil
    const [owLocationGroups] = useRecoilState(owLocationGroupAtom);
    const [selectedOWLocationGroupLocation] = useRecoilState(selectedOWLocationGroupLocationAtom);

    return (
        <Grid container spacing={2} alignItems="start">
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("location")}
                    label={t("pricing:owLocations.form.labels.location")}
                    options={[]}
                    multiple={false}
                    isOptionEqualToValue={(option: SelectElementModelFE, value: SelectElementModelFE) => option.code === value.code}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("owLocationGroup")}
                    label={t("pricing:owLocations.form.labels.owLocationGroup")}
                    options={owLocationGroups.filter(lg => lg.code !== selectedOWLocationGroupLocation?.owLocationGroup.id && lg.legalEntity === selectedOWLocationGroupLocation?.owLocationGroup.legalEntity)}
                    multiple={false}
                    isOptionEqualToValue={(option, value) => option.code === value.code}
                />
            </Grid>
        </Grid>
    );
};

export default FormOWLocationGroupLocation;